import { api } from '@/portal-api.definition';
import { ActionType } from '@nosinovacao/nosid-mfe-common';
import { useNosIdMutation } from './base.hooks';
import { auth } from '@/lib';

export function useDeleteAccount({ onSuccess }: { onSuccess?: () => void } = {}) {
  return useNosIdMutation({
    mutationFn: () => api.delete('/api/v1/users'),
    successLogAction: () => ({
      ActionType: ActionType.DeleteUser,
      Option: '',
    }),
    errorLogAction: () => ({
      ActionType: ActionType.DeleteUser,
      Option: '',
    }),
    onSuccess: async () => {
      onSuccess?.();
      await auth.logout(false, true);
      localStorage.clear();
    },
  });
}
